/** A server-issued deadline, never a fresh five minutes on mount or reconnect. */
import { useEffect, useMemo, useState } from "react";
export function RepairClock({
  deadline,
  serverTime,
  receivedAt,
}: {
  deadline: string;
  serverTime?: string;
  receivedAt?: number;
}) {
  const [now, setNow] = useState(Date.now());
  const offset = useMemo(
    () =>
      serverTime &&
      receivedAt !== undefined &&
      Number.isFinite(receivedAt) &&
      Number.isFinite(Date.parse(serverTime))
        ? Date.parse(serverTime) - receivedAt
        : 0,
    [serverTime, receivedAt],
  );
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, []);
  const end = Date.parse(deadline);
  if (!Number.isFinite(end)) return null;
  const seconds = Math.max(0, Math.ceil((end - now - offset) / 1000));
  return (
    <p className="run-repair" role="status">
      Equipment repair ·{" "}
      {seconds === 0
        ? "Repair time elapsed"
        : `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")} remaining`}
      {" · "}
      <time dateTime={deadline}>
        Deadline {new Date(end).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
      </time>
    </p>
  );
}
